// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"ac429653","160":"5682b20b","565":"0ba4f477","763":"7da6b05b","782":"582a7fe9","831":"37eb90b6"}[chunkId] + ".chunk.js";
};